export const getUsername = async () => {
  try {
    const response = await fetch('/api/v1/username', {
      credentials: 'include',
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json().catch(() => null);
    return data && data.username ? data.username : null;
  } catch (error) {
    return null;
  }
};

